export default {
  async getGroups() {
    return this.request('/groups');
  },

  async getGroup(groupId) {
    return this.request(`/groups/${groupId}`);
  },
};
